export default "__VITE_ASSET__OiVfYF0Y__"